export enum InvoicingViewByDays {
    Last30Days = 'Last 30 Days',
    Last60Days = 'Last 60 Days',
    Last90Days = 'Last 90 Days',
    Last90PlusDays = '90+ Days'
}

export enum InvoiceCreatedType {
    Default = 'Default',
    FromJob = 'From Job',
    FromWorkOrder = 'From WorkOrder',
    FromPurchaseOrder = 'From Purchase Order',
}